<template>
  <div class="web_home" v-if="isMaxScreen">
      <!-- 主体内容 -->

      <!-- 轮播图开始 -->
      <section class="web_focus">
          <!-- <img class="home_image_foucs" src="@/assets/img/foucs01.png" alt=""> -->
        <el-carousel arrow="never" trigger="click">
          <el-carousel-item
            v-for="(item,index) in imgList"
            :key="index"
            :style="`background: url(${item}) center no-repeat`">
            <!-- <img :src="item" alt="" /> -->
          </el-carousel-item>
        </el-carousel>
      </section>
      <!-- 轮播图结束 -->
      <!-- 动态新闻/快捷入口开始 -->
      <section class="web_news common">
        <div class="news_left">
           <div class="news_header common_header">
             <div class="header_left">
                <div v-for="(item, index) in headerTitle" :key="index"
                     :class="id === index ? 'active' : '' "
                     @click="changeClass(item.id)">{{item.name}}</div>
             </div>
              <div class="header_right" @click="toPage">
                <div class="header_block">MORE</div>
                <div class="header_block">>></div>
             </div>
           </div>
           <div class="news_list">
             <div class="news_item"
                  v-for="item in list1" :key="item.id"
                  @click="clickNew(item)">
                <div class="news_text">
                  <div class="news_time">
                    <div class="news_day">{{item.day}}</div>
                    <div>{{item.year}}.{{item.month}}</div>
                  </div>
                  <span>{{item.title}}</span>
                </div>
                <span>[全文]</span>
             </div>
           </div>
        </div>
        <div class="news_right">
           <div class="subnavs">
              <div class="subnav_item"
                   v-for="(item,index) in subnavsList" :key="index"
                   @click="isPush(item)">
               <img :src="item.imgUrl" alt="">
             </div>
           </div>
        </div>
      </section>
      <!-- 动态新闻/快捷入口结束 -->
      <!-- 招生新闻/就业创业开始 -->
      <section class="w1920">
        <section class="web_students common">
          <div class="news_left">
           <div class="news_header common_header">
             <div class="header_left">
                <div v-for="(item, index) in headerTitle1" :key="index"
                     :class="id1 === index ? 'active' : '' "
                     @click="changeClass(item.id)">{{item.name}}</div>
             </div>
              <div class="header_right" @click="toPage2">
                <div class="header_block">MORE</div>
                <div class="header_block">>></div>
             </div>
           </div>
           <div class="news_list">
             <div class="news_item" @click="clickNew(item)"
                  v-for="item in list2" :key="item.id">
               <p>{{item.title}}</p>
               <span>{{item.create_time}}</span>
             </div>
           </div>
          </div>

           <div class="news_left news_right">
           <div class="news_header common_header">
             <div class="header_left">
                <div class="active">就业创业</div>
             </div>
              <div class="header_right" @click="$router.push('/work/jycy?ids=0')">
                <div class="header_block">MORE</div>
                <div class="header_block">>></div>
             </div>
           </div>
           <div class="news_list">
             <div class="news_item" @click="toArticle(item, '就业创业', 0, $nav16)"
                  v-for="item in list3" :key="item.id">
               <p style="width: 326px">{{item.title}}</p>
               <span>{{item.create_time}}</span>
             </div>
           </div>
          </div>
        </section>
      </section>
      <!-- 招生新闻/就业创业结束 -->
      <!-- 多彩校园开始 -->
      <section class="web_campus common">
        <div class="news_left campus_header">
           <div class="news_header common_header">
             <div class="header_left">
                <div v-for="(item, index) in headerTitle2" :key="index"
                     :class="id2 === index ? 'active' : '' "
                     @click="changeClass(item.id)">{{item.name}}</div>
             </div>
              <div class="header_right" @click="toPage3">
                <div class="header_block">MORE</div>
                <div class="header_block">>></div>
             </div>
           </div>
        </div>
        <div v-if="id2 === 0" class="campus_main">
          <div class="campus_left" v-for="item in videoList1" :key="item.id" @click="onPaly(item)">
            <img :src="item.cover_url === '' ? '@/assets/img_pc/home12.png' : item.cover_url" alt="">
            <div class="player"><img src="@/assets/img_pc/home13.png" alt=""></div>
          </div>
          <div class="campus_right">
            <div class="campus_list campus_videoItem">
              <div class="campus_item" v-for="item in videoList2" :key="item.id"  @click="onPaly(item)">
                 <img :src="item.cover_url === '' ? '@/assets/img_pc/home12.png' : item.cover_url" alt="">
                <div class="player size"><img src="@/assets/img_pc/home13.png" alt=""></div>
              </div>
            </div>
            <div class="campus_list campus_imgItem">
              <div class="campus_item" @click="toStudents(index)" v-for="(item, index) in imageList" :key="index">
                <img :src="item.imgUrl" alt="">
              </div>
            </div>
          </div>
        </div>

        <div v-if="id2 === 1" class="campus_main">
          <div class="campus_left" v-for="item in list4" :key="item.id">
            <el-image
                  style="width: 100%; height: 100%"
                  :src="item.image_url"
                  :preview-src-list="srcList">
                </el-image>
            <!-- <img :src="item.cover_url === '' ? '@/assets/img_pc/home12.png' : item.image_url" alt="">      -->
          </div>
          <div class="campus_right">
            <div class="campus_list campus_videoItem">
              <div class="campus_item" v-for="item in list5" :key="item.id">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="item.image_url"
                  :preview-src-list="srcList">
                </el-image>
                 <!-- <img :src="item.cover_url === '' ? '@/assets/img_pc/home12.png' : " alt=""> -->
              </div>
            </div>
            <div class="campus_list campus_imgItem">
              <div class="campus_item" @click="toStudents(index)" v-for="(item, index) in imageList" :key="index">
                <img :src="item.imgUrl" alt="">
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 多彩校园结束 -->
       <section class="web_links">
         <div class="web_links_header active">常用链接</div>
         <div class="web_links_list">
           <u v-for="item in linksList" :key="item.id" @click="toExternal(item)">
             {{item.title}}
           </u>
         </div>
      </section>
  </div>
  <HomeH5 v-else />
</template>

<script>
import HomeH5 from '@/views/app/home/index'
export default {
  name: '',
  components: { HomeH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      id: 0,
      id1: 0,
      id2: 0,
      headerTitle: [{ id: 0, name: '招生动态' }, { id: 1, name: '就业动态' }],
      headerTitle1: [{ id: 2, name: '单招' }, { id: 3, name: '对口' }, { id: 4, name: '统考' }],
      headerTitle2: [{ id: 5, name: '多彩校园' }, { id: 6, name: '校园风光' }],

      imgList: [require('@/assets/img_pc/banner.png'),
        require('@/assets/img_pc/banner1.png'),
        require('@/assets/img_pc/banner2.png')
      ],
      subnavsList: [
        { imgUrl: require('@/assets/img_pc/home1.png'), title: '院系专业', url: '/zszy', id: 3 },
        { imgUrl: require('@/assets/img_pc/home2.png'), title: '招生计划', url: '/zsjh', id: 4 },
        { imgUrl: require('@/assets/img_pc/home3.png'), title: '历年分数', url: '/lnfs', id: 0 },
        { imgUrl: require('@/assets/img_pc/home4.png'), title: '招生简章', url: '/zsxx/dtxx', id: 0 },
        { imgUrl: require('@/assets/img_pc/home5.png'), title: '校园动态', url: '/xydt', id: 0 },
        { imgUrl: require('@/assets/img_pc/home6.png'), title: '奖助政策', url: '/jzzc', id: 0 }
      ],
      imageList: [
        { imgUrl: require('@/assets/img_pc/home10.png') },
        { imgUrl: require('@/assets/img_pc/home11.png') }
      ],
      linksList: [
        { id: 0, path: 'http://www.gxou.com.cn/', title: '广西开放大学' },
        { id: 1, path: 'http://jyt.gxzf.gov.cn/', title: '广西壮族自治区教育厅' },
        { id: 2, path: 'https://www.gxeea.cn/', title: '广西招生考试院' },
        { id: 3, path: 'https://gaokao.chsi.com.cn', title: '阳光高考教育平台' }
      ],
      videoParams: { page: 1, page_size: 3, type: 1 },
      videoList1: [],
      videoList2: [],
      list1: [],
      list2: [],
      list3: [],
      column_id: 3,
      column_id2: 15,
      column_id3: 14,

      list4: [],
      list5: [],
      srcList: [],
      type: 1
    }
  },
  computed: {

  },
  watch: {},
  created () {
    this.getList()
    this.getList1()
    this.getList2()
    this.getList3()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      this.isMaxScreen = document.body.clientWidth > 850
    })
  },
  methods: {
    changeClass (id) {
      switch (id) {
        case 0:
          this.id = 0
          this.column_id = 3
          this.getList1()
          break
        case 1:
          this.id = 1
          this.column_id = 13
          this.getList1()
          break
        case 2:
          this.id1 = 0
          this.column_id2 = 15
          this.getList2()
          break
        case 3:
          this.id1 = 1
          this.column_id2 = 16
          this.getList2()
          break
        case 4:
          this.id1 = 2
          this.column_id2 = 17
          this.getList2()
          break
        case 5:
          this.id2 = 0
          this.getList()
          break
        case 6:
          this.id2 = 1
          this.getList4()
      }
    },
    toPage () {
      if (this.id === 0) {
        this.$router.push('/zsxx/zsdt?ids=0')
      } else {
        this.$router.push('/work/jydt?ids=0')
      }
    },
    toPage2 () {
      if (this.id1 === 0) {
        this.$router.push('/zsxx/single?ids=0')
      } else if (this.id1 === 1) {
        this.$router.push('/zsxx/counterpart?ids=0')
      } else {
        this.$router.push('/zsxx/series?ids=0')
      }
    },
    toPage3 () {
      if (this.id2 === 0) {
        this.$router.push('/campus?ids=0')
      } else {
        this.$router.push('/xyfg?ids=1')
      }
    },
    isPush (item) {
      this.$router.push(item.url + '?ids=0')
      this.$store.commit('setIds', item.id)
    },
    toExternal (item) {
      if (item.path === '') {
        alert('敬请期待...')
      } else {
        window.open(item.path)
      }
    },
    onPaly (item) {
      this.$router.push({ path: '/campus/details?ids=0', query: { url: item.video_url } })
    },
    toStudents (index) {
      if (index === 0) {
        this.$router.push('/xxjj/szll?ids=0')
      } else {
        this.$router.push('/xxjj/student?ids=0')
      }
    },
    clickNew (item) {
      if (this.id === 0) this.toArticle(item, '招生动态', 0, this.$nav14)
      else if (this.id === 1) this.toArticle(item, '就业动态', 0, this.$nav15)
      else if (this.id1 === 0) this.toArticle(item, '单招', 0, this.$nav17)
      else if (this.id1 === 1) this.toArticle(item, '对口', 0, this.$nav18)
      else if (this.id1 === 2) this.toArticle(item, '统考', 0, this.$nav19)
    },
    toArticle (item, title, ids, nav) {
      if (item.is_jump === 0) {
        this.$router.push({
          path: '/article',
          query: { id: item.id, title, ids }
        })
        console.log(nav)
        this.$store.commit('setSidebar', nav)
      } else {
        window.open(item.jump_url)
      }
    },
    async getList () {
      const { data } = await this.$get('/ow/video', this.videoParams)
      this.videoList1 = data.filter((item, index) => { if (index === 0) { return item } })
      this.videoList2 = data.filter((item, index) => { if (index > 0) { return item } })
    },
    async getList1 () {
      const { data } = await this.$get('/ow/article', { page: 1, page_size: 6, column_id: this.column_id })
      const list = data.map(item => {
        return { ...item, ...this.$util.getDateObj(item.create_time) }
      })
      this.list1 = list
    },
    async getList2 () {
      const { data } = await this.$get('/ow/article', { page: 1, page_size: 8, column_id: this.column_id2 })
      this.list2 = data
    },
    async getList3 () {
      const { data } = await this.$get('/ow/article', { page: 1, page_size: 8, column_id: this.column_id3 })
      this.list3 = data
    },
    async getList4 () {
      const { data } = await this.$get('/ow/scenery', { page: 1, page_size: 3, type: this.type })
      this.list4 = data.filter((item, index) => { if (index === 0) { return item } })
      this.list5 = data.filter((item, index) => { if (index > 0) { return item } })
      this.srcList = data.map(item => { return item.image_url })
    }
  }

}
</script>

<style lang="scss" scoped>
  // $width: ;
  $fontSize: 16px;
  $height: 340px;
  $wh: 96px;
  $wid: 600px;
  $hei: 300px;
  $fs20: 20px;
  .web_home {
    font-size: $fontSize;
    color: #999;
  }
  .w1920 {
    width: 100%;
    min-height: 420px;
    margin: 42px 0;
    background: #F3F5F9;
    padding: 24px;
  }
  .web_home {
    margin-bottom: 42px;
    .web_focus {
        width: 100%;
        height: 450px;
        position: relative;
        color: #fff;
        margin-bottom: 40px;
        ::v-deep .el-carousel__button{
            width: 10px!important;
            height: 10px!important;
            border-radius: 50%!important;
            background: #4E55AF;
        }
        ::v-deep .el-carousel__item {
          background-size: 100% 450px!important;
        }
    }

  }
  .common {
    width: 1200px;
    min-height: 424px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .news_left {
      min-width: 665px;
      .news_list {
        width: 100%;
        .news_item {
          width: 100%;
          padding-top: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          p, .news_text>span {
            width: 420px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #414141;
          }
          p::before {
              content: '';
              display: inline-block;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #FF8660;
              margin-bottom: 3px;
              margin-right: 10px;
          }
          .news_text {
            width: 480px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .news_time {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 48px;
            height: 38px;
            margin-right: 20px;
            background: #EDEDED;
            font-size: 10px;
            color: #4E55AF;
            .news_day {
              width: 100%;
              height: 24px;
              font-size: 16px;
              background: #4E55AF;
              color: #fff;
              text-align: center;
              line-height: 24px;
            }
          }
        }
      }
    }
    .news_right {
      min-width: 501px;
      margin-left: 34px;
      .subnavs {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        cursor: pointer;
        .subnav_item {
          width: 167px;
          height: 212px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          font-size: 18px;
          background: #4E55AF;
        }
      }
    }
    .common_header {
      display: flex;
      justify-content: space-between;
      min-height: 50px;
      border-bottom: 1px solid #DFDFDF;
      cursor: pointer;
      .header_left {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #999999;
        &::before {
          content: '';
          width: 8px;
          height: 8px;
          background: #4E55AF;
          margin-right: 10px;
        }
        &>div:nth-child(2n) {
          margin: 0 20px;
        }
      }
      .header_right {
        display: flex;
        align-items: center;
        color: #4E55AF;
        &>div:first-child {
          margin-right: 10px;
        }
      }
    }
  }
  .web_campus {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .common .campus_header {
    min-width: 1200px;
  }
  .campus_main {
    width: 1200px;
    min-height: 426px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;

    .campus_right, .campus_left {
      width: 580px;
      height: 100%;
      cursor: pointer;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .player {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 72px;
      height: 72px;
    }
    .size {
      width: 48px;
      height: 48px;
    }
    .campus_left {
      position: relative;
      width: 586px;
    }
    .campus_right {
      display: flex;
      justify-content: space-between;
    }
    .campus_list {
      width: 277px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .campus_item {
       position: relative;
       width: 100%;
       height: 199px;
      }
    }
  }
  .web_links {
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    font-size: 18px;
    .web_links_list {
      padding: 0 10px;
    }
    .web_links_header {
      display: flex;
      align-items: center;
      min-height: 50px;
      font-size: 22px;
      margin-bottom: 20px;
      border-bottom: 1px solid #DFDFDF;
      &::before {
        content: '';
        width: 8px;
        height: 8px;
        background: #006699;
        margin-right: 10px;
      }
    }
    u {
      color: #31378E;
      cursor: pointer;
      margin-right: 76px;

    }
    u:last-child {
       margin-right: 0;
    }
  }
  .active {
    color: #333;
  }
</style>
